import { axios } from '@Root/API'

export const getNotTrashed = id => {
	return axios.get(`student-application/into-trash/${id}`)
}
